import React from 'react';
// @ts-ignore
import styles from './DENTModalOverviewSubButtonsSelection.module.scss';
import DENTButton from '../../../Base/Components/DENT/DENTButton/DENTButton';
import useTranslation from '../../../../Hooks/useTranslation';

interface SubButton {
	title: string;
	isSelected: boolean;
	onClick: () => void;
}

interface Row {
	shouldHide: boolean;
	title?: string;
	items: SubButton[];
}

interface Props {
	rows: Row[];
}

const DENTModalOverviewSubButtonsSelection = ({ rows }: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			{rows.map((row, index) => {
				if (row.shouldHide) {
					return null;
				}

				return (
					<div className={styles.rowContainer} key={`row-${index}`}>
						{row.title && <h2>{t(row.title)}</h2>}
						<div className={styles.row} key={`row-${index}`}>
							{row.items.map(subButton => (
								<DENTButton
									key={subButton.title}
									title={subButton.title}
									isSelected={subButton.isSelected}
									onClick={subButton.onClick}
								/>
							))}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default DENTModalOverviewSubButtonsSelection;
